import React, { useState } from 'react';
import cn from 'classnames';
import { useUID } from 'react-uid';
import { EXPANDER_LEFT, EXPANDER_NONE, EXPANDER_RIGHT } from './types';
import TableCell from './TableCell';
import { ExpanderRow } from './ExpanderRow';
import ExpanderCell from './ExpanderCell';
import { attributesFromTupleArray } from './Table';
export const TableRow = ({ row, rowIndex, rowSelected = () => false, rowHighlighted = () => false, isRowStriped, columns, rowSpans, expandableRows, expanderPosition, expandableIconClosed = 'down', expandableIconOpen = 'up', expandableRowExpanded = 'isExpanded', expandableRowDisabled = 'isExpandDisabled', expandableRowComponent, expanderButtonLabel = 'Expand the row for more information', onRowExpandToggled, a11yHighlightText, a11ySelectedText, a11yHighlightType, rowAttributes, rowAttributesFunc, rowClassNameFunc, }) => {
    // update the expander position based on the global enable flag
    const expander = expandableRows ? expanderPosition : EXPANDER_NONE;
    const isRowHighlighted = rowHighlighted(row);
    const isRowSelected = rowSelected(row);
    const [isDisabled] = useState(typeof expandableRowDisabled === 'string' ? row[expandableRowDisabled] : expandableRowDisabled(row));
    const [isExpanded, setIsExpanded] = useState(typeof expandableRowExpanded === 'string' ? row[expandableRowExpanded] : expandableRowExpanded(row));
    const rowId = `row_${useUID()}`;
    /**
     * Toggle the expanded prop on click
     */
    const expandOnClick = () => {
        onRowExpandToggled && onRowExpandToggled(row, !isExpanded);
        setIsExpanded(value => !value);
    };
    const getExpanderLabel = () => {
        if (typeof expanderButtonLabel === 'string') {
            return expanderButtonLabel;
        }
        return expanderButtonLabel ? expanderButtonLabel(row, isExpanded) : '';
    };
    /**
     * Render the expander cell code
     */
    const renderExpander = () => {
        return (React.createElement(ExpanderCell, { ariaControls: rowId, expandableIconOpen: expandableIconOpen, expandableIconClosed: expandableIconClosed, isDisabled: isDisabled, isExpanded: isExpanded, expanderButtonLabel: getExpanderLabel, onClick: expandOnClick }));
    };
    const rowClassName = cn(isRowSelected && 'cb-table-selected', isRowHighlighted && 'cb-table-highlight', isRowStriped === true && 'cb-stripe', isRowStriped === false && 'cb-no-stripe', rowClassNameFunc && rowClassNameFunc(row));
    const rowAttributesProps = Object.assign(Object.assign({}, (rowAttributes && attributesFromTupleArray(rowAttributes))), (rowAttributesFunc && attributesFromTupleArray(rowAttributesFunc(row))));
    let spanCount = 1;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", Object.assign({ key: `row-${rowIndex}`, className: rowClassName }, rowAttributesProps),
            expander === EXPANDER_LEFT && renderExpander(),
            columns.map(({ props }, colIndex) => {
                if (spanCount > 1) {
                    spanCount -= 1;
                    return null;
                }
                spanCount = props.onColSpan ? props.onColSpan(row, rowIndex) : 1;
                if (props && props.groupValues && !rowSpans[props.field][rowIndex])
                    return null;
                return (React.createElement(TableCell, Object.assign({ key: `row-${rowIndex}-col-${props.field}-${colIndex}`, row: row, rowIndex: rowIndex, rowSpan: props.groupValues ? rowSpans[props.field][rowIndex] : undefined, colSpan: spanCount, a11yHighlightType: a11yHighlightType, a11yHighlightText: a11yHighlightText, a11ySelectedText: a11ySelectedText, isRowHighlighted: isRowHighlighted, isRowSelected: isRowSelected, id: (props.cellId && props.cellId(row, rowIndex)) || undefined, headers: (props.cellHeaders && props.cellHeaders(row, rowIndex)) || undefined }, props)));
            }),
            expander === EXPANDER_RIGHT && renderExpander()),
        expandableRows && !isDisabled && (React.createElement(ExpanderRow, { id: rowId, colSpan: columns.length + 1, row: row, rowIndex: rowIndex, isExpanded: isExpanded, expandableRowComponent: expandableRowComponent, expanderPosition: expander, className: rowClassName }))));
};
export default TableRow;
//# sourceMappingURL=TableRow.js.map